import axios from "axios";
import environment from "constants/apiConst";

export const __ReasonReturn = async (token, body) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
    data: body || ""
  };

  const res = await axios(`${environment.GET_RETURN_REASON}`, options);
  return res;
};
